/** Link wa.me: assume Brasil (+55) quando o número não traz DDI. */
export function whatsappLink(raw: string | null): string | null {
  if (!raw) return null;
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  const full = raw.startsWith('+') || digits.length > 11 ? digits : `55${digits}`;
  return `https://wa.me/${full}`;
}

/** "11988887777" → "(11) 98888-7777" */
export function formatPhone(raw: string | null): string {
  if (!raw) return '';
  const d = raw.replace(/\D/g, '');
  const local = d.length > 11 && d.startsWith('55') ? d.slice(2) : d;
  if (local.length === 11) return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  if (local.length === 10) return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  return raw;
}
